<script setup>
import { Primitive, useForwardPropsEmits, } from 'radix-vue';
import { computed, useAttrs, } from 'vue';
import { cn, } from '@/utils/ShadcnUtil';


import { buttonVariants, } from '~/components/ui/button/index';

const props = defineProps({
  variant: { type: null, required: false, default: 'default' },
  size: { type: null, required: false, default: null },
  class: { type: null, required: false, default: '' },
  asChild: { type: Boolean, required: false, default: false },
  as: { type: null, required: false, default: 'button' },
  text: { type: String, required: false, default: '' },
  disabled: { type: Boolean, required: false, default: false },
  modelValue: { type: [
    String, Number, Object, Boolean,
  ], required: false, default: null },
});
const emits = defineEmits(['update:modelValue', 'click']);

const attrs = useAttrs();

const delegatedProps = computed(() => {
  const { class: _, ...delegated } = props;

  return delegated;
});

const forwarded = useForwardPropsEmits(delegatedProps, emits);

// Combine forwarded props and attrs
const mergedProps = computed(() => {
  return {
    ...forwarded,
    ...attrs,
  };
});

</script>

<template>
  <slot name="left-icon" />
  <Primitive
    :v-bind="attrs"
    :as="as"
    :as-child="asChild"
    :class="cn(buttonVariants({ intent: props.variant }), props.class)"
    :disabled="disabled"
    @click="$emit('click', $event)"
  >
    <slot />
  </Primitive>
</template>

<script>
export default {
  name: 'ButtonComponent',
  // mounted () {
  //   console.log('btn mounted', cn(buttonVariants({intent: 'outlinedSmall'}), this.props.class));
  // },
};
</script>

<style>
button:disabled,
.disabled {
  opacity: 0.5;
  cursor: not-allowed;
  background-color: #f3f4f6; /* bg-gray-100 */
  border-color: #d1d5db; /* border-gray-300 */

  &:hover {
    background-color: #f3f4f6; /* bg-gray-100 */
    border-color: #d1d5db; /* border-gray-300 */
    color: #6b7280; /* text-gray-500 */
  }
} </style>
